
import React, { Component } from 'react';
import CdnImage from '../../components/cdnImage/cdnImage.js'
import { Container, Row } from 'reactstrap';

const configurationManager = require('../../utils/config/configurationManager.js');
const themeUtil = require('../../utils/view/themeUtil');
const translator = require('../../utils/translator/translator')
const localizationUtils = require('../../utils/domain/localizationUtils.js')

class PassportExpiredView extends Component 
{
    render()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;

        return (<div className='h-100 w-100 d-flex justify-content-center align-items-center'>
                    <Container>

                        <CdnImage cloudName={cloudName} height={150} publicId={themeUtil.getLoadingViewLogo()}/>  

                        <div style={{fontSize:'1.2rem', textAlign:'center', marginTop:'20px', color:'var(--colors-error)', marginLeft:'25px'}}>
                            {translator.getLabel("your_session_is_expired_please_restart_your_app")}
                        </div>

                        <div className='w-100' style={{position:'fixed', bottom:0, left:0}}>
                            <div style={{marginBottom:'20px'}}>
                                {this.renderHelpContacts()}
                            </div>
                        </div>
                    </Container>
                </div>);
    }

    renderHelpContacts()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        
        return <div className='h-100 w-100' lassName='primary-color' style={{textAlign:'center'}}>
                    <div className="w-100 d-flex flex-row justify-content-center align-items-center">
                        
                        <div className='make-child-img-full-width' style={{width:"1.3rem", height:'1.7rem'}}>
                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('whatsapp.png')}/>
                        </div>
                        <div >
                            {translator.getLabel("whatsapp_support")}: {localizationUtils.getSupportWhatsAppNumber()}
                        </div>
                        
                        <div className='make-child-img-full-width' style={{marginLeft:'60px', width:"1.3rem", height:'1.7rem'}}>
                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('email.png')}/>
                        </div>
                        <div >
                            {translator.getLabel("email_support")}: {localizationUtils.getSupportEmailAddress()}
                        </div>

                        <div className='make-child-img-full-width' style={{marginLeft:'60px', width:"1.3rem", height:'1.7rem'}}>
                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('phone.png')}/>
                        </div>
                        <div >
                            {translator.getLabel("phone_support")}: {localizationUtils.getSupportPhoneNumber()}
                        </div>
                    </div>
                </div>   
    }
}

export default PassportExpiredView